import styles from './QCStepFooter.module.css';

export interface QCStepFooterProps {
  currentStepLabel: string;
  previousStepLabel?: string;
  nextStepLabel?: string;
  onPreviousStep: () => void;
  onNextStep: () => void;
  canGoPrevious: boolean;
  canGoNext: boolean;
}

export function QCStepFooter({
  currentStepLabel,
  previousStepLabel,
  nextStepLabel,
  onPreviousStep,
  onNextStep,
  canGoPrevious,
  canGoNext
}: QCStepFooterProps) {
  return (
    <footer className={styles.footer}>
      <div className={styles.navGroup}>
        <button
          type="button"
          className={styles.arrowButton}
          onClick={onPreviousStep}
          disabled={!canGoPrevious}
        >
          &lt;
        </button>
        <div className={styles.stepInfo}>
          <span className={styles.stepLabel}>{currentStepLabel}</span>
          <div className={styles.hintRow}>
            <span className={styles.hint}>
              {canGoPrevious && previousStepLabel ? `Back: ${previousStepLabel}` : 'At first step'}
            </span>
            <span className={styles.separator}>•</span>
            <span className={styles.hint}>
              {canGoNext && nextStepLabel ? `Next: ${nextStepLabel}` : 'Final step'}
            </span>
          </div>
        </div>
        <button
          type="button"
          className={styles.arrowButton}
          onClick={onNextStep}
          disabled={!canGoNext}
        >
          &gt;
        </button>
      </div>
    </footer>
  );
}

export default QCStepFooter;
